import { simpleSet } from '@r/reducers/utils';

const setCalculationModeAdminSettingsLegsValue = simpleSet as
  redux.reducers.calculationMode.adminSettings.projectSettings.materials.legs.value;

export const value = setCalculationModeAdminSettingsLegsValue(
  'SET_CALCULATION_MODE_ADMIN_SETTINGS_LEGS_VALUE',
  { value: '', label: '' }
);
